import { obtenerPcIdActual } from "./configuracionPc";
import { obtenerSesion } from "./sesionSeguridad";

const storageActual = (storage) => storage ?? globalThis.localStorage;

const leer = (storage, ...claves) => {
  const origen = storageActual(storage);
  for (const clave of claves) {
    const valor = origen?.getItem?.(clave);
    if (valor !== null && valor !== undefined && valor !== "") return valor;
  }
  return null;
};

export const obtenerOperadorIdActual = (storage) =>
  obtenerSesion()?.OperadorId || Number(leer(storage, "OperadorId", "Id")) || 0;

export const obtenerContextoSesion = ({ EmpresaId = 0, storage } = {}) => ({
  EmpresaId: obtenerSesion()?.EmpresaId || Number(EmpresaId) || 0,
  operadorId: obtenerOperadorIdActual(storage),
  pcId: obtenerPcIdActual(),
});

// Compatibilidad temporal con endpoints legacy. La contraseña debe retirarse
// cuando el servidor acepte el token de sesión en estas operaciones.
export const obtenerAuditoriaListaPrecios = (storage) => ({
  Operador_Id: obtenerOperadorIdActual(storage),
  PcId: obtenerPcIdActual(),
  User: String(leer(storage, "Mail") || ""),
  Pass: "",
});
